module.exports = __webpack_public_path__ + "img/category-alchemy-reverse.53f9f83f.svg";